import Avatar from "./Avatar";
import { useAvatarColors } from "hooks/useAvatarColors";

const UserAvatar = ({ userId, withColors = true, ...props }) => {
  const { color, textColor } = useAvatarColors(userId);

  return <Avatar {...(withColors && { color, textColor })} {...props} />;
};
export default UserAvatar;
